import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';

export class TokenGenerator {
  private static readonly SECRET = environment.cryptoKey;

  static generateToken(): string {
    const payload = { timestamp: Date.now() };
    const payloadString = JSON.stringify(payload);
    const signature = CryptoJS.HmacSHA256(payloadString, this.SECRET).toString(CryptoJS.enc.Hex);
    const tokenObj = { payload, signature };
    return btoa(JSON.stringify(tokenObj)); // Base64 dell'oggetto completo
  }
}